import { IBriefResource } from "../../briefs";
import { EntityTypes } from "../../EntityTypes";
import { ILanguageResource } from "../../languages";
import { IProfessionalSituationResource } from "../../professional-situations";
import { ISkillResource } from "../../skills";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";

export interface IProfessionalSituationUpdateMutationParameters {
    professionalSituation: RelationalValue<IProfessionalSituationResource>;
    title?: string;
    targetedDomain?: string;
    problematic?: string;
    description?: string;
    language: RelationalValue<ILanguageResource>;
    skills: RelationalValue<ISkillResource>[];
    briefs?: RelationalValue<IBriefResource>[];
}

export type IProfessionalSituationUpdateMutationResult = IProfessionalSituationResource;

export const professionalSituationUpdateMutation: IApiMutationFunction<
    IProfessionalSituationUpdateMutationParameters
> = ({ professionalSituation, language, skills, briefs, ...data }) => ({
    method: "PUT",
    url: `/professional_situations/${mapRelationalValue(professionalSituation)}`,
    data: {
        ...data,
        language: mapRelationalValueAsIRI(EntityTypes.LANGUAGE, language),
        skills: skills.map(skill => mapRelationalValueAsIRI(EntityTypes.SKILL, skill)),
        briefs: briefs?.map(brief => mapRelationalValueAsIRI(EntityTypes.BRIEF, brief)),
    },
});

export const useProfessionalSituationUpdateMutation = createApiMutationHook<
    IProfessionalSituationUpdateMutationParameters,
    IProfessionalSituationUpdateMutationResult
>(professionalSituationUpdateMutation);
